import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { DrawdownType } from "../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { PensionContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { TopUpWithITFLSDispatcher } from "./Variable";

export interface TopUpWithITFLSStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: PensionContributionModel;
}

export class TopUpWithITFLSStoreStatic extends BaseStore<TopUpWithITFLSStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(TopUpWithITFLSDispatcher, (actionData) => this.onTopUpWithITFLSResponse(actionData));
    }

    public getLastResult(): TopUpWithITFLSStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        // const _data: PensionContributionModel = JSON.parse(JSON.stringify(this.getState().data));
        // if (_data?.Contribution?.DrawdownModel?.CrystallisationDetails) {
        //     _data.Contribution.DrawdownModel.CrystallisationDetails.AvailableToCrystallise = {
        //         Amount: 100000,
        //         Currency: CurrencyCode.GBP,
        //     };
        //     _data.Contribution.DrawdownModel.CrystallisationDetails.CrystallisedValue = {
        //         Amount: 100000,
        //         Currency: CurrencyCode.GBP,
        //     };
        //     _data.Contribution.DrawdownModel.CrystallisationDetails.UnCrystallisedValue = {
        //         Amount: 100000,
        //         Currency: CurrencyCode.GBP,
        //     };
        //     _data.Contribution.DrawdownModel.CrystallisationDetails.AvailableCash = {
        //         Amount: 10000,
        //         Currency: CurrencyCode.GBP,
        //     };
        // }
        // if (_data?.Contribution?.DrawdownModel) {
        //     _data.Contribution.DrawdownModel.CurrentPclsEntitlement = {
        //         Amount: 13413.75,
        //         Currency: CurrencyCode.GBP,
        //     };
        // }

        // if (_data?.Contribution?.DrawdownModel) {
        //     _data.Contribution.DrawdownModel.LifetimeAllowance = {
        //         ChargeableCrystallisationPortion: {
        //             Amount: 46345,
        //             Currency: CurrencyCode.GBP,
        //         },
        //         AvailablePersonalAllowance: {
        //             Amount: 53655,
        //             Currency: CurrencyCode.GBP,
        //         },
        //         SlaBenefitsPriorTo2006: 5,
        //         TotalSlaUsed: 104.31,
        //         SlaPreviouslyCrystallised: 90,
        //         SlaUsedByProposedCrystallisation: 9.31,
        //     };
        // }

        // if (
        //     _data?.Contribution?.DrawdownModel &&
        //     _data?.Contribution?.DrawdownModel?.DrawdownType !== DrawdownType.Regular
        // ) {
        //     _data.Contribution.DrawdownModel.ExistingArrangements = {
        //         CappedModels: [
        //             {
        //                 Id: 1111,
        //                 From: "1111",
        //                 Amount: 100000,
        //                 Type: "Member",
        //                 GadMaximum: 15000,
        //                 Taxable: true,
        //                 IncomeTakenToDate: 1300,
        //                 NextYearsGadMaximum: 20000,
        //                 LastMandatoryReview: JsonDateParser.toJsonDateNoOffset(new Date(2020, 1, 1)),
        //                 MaximumIncomePaymentForRemainderOfPensionYear: 1000,
        //                 MaximumIncomePaymentForFuturePensionYears: 2000,
        //             },
        //             {
        //                 Id: 3333,
        //                 From: "3333",
        //                 Amount: 200000,
        //                 Type: "Inherited",
        //                 GadMaximum: 20000,
        //                 Taxable: false,
        //                 IncomeTakenToDate: 1300,
        //                 NextYearsGadMaximum: 10000,
        //                 LastMandatoryReview: JsonDateParser.toJsonDateNoOffset(new Date(2020, 1, 1)),
        //                 MaximumIncomePaymentForRemainderOfPensionYear: 1000,
        //                 MaximumIncomePaymentForFuturePensionYears: 2000,
        //             },
        //         ],
        //         FlexiModels: [
        //             {
        //                 Id: 1234,
        //                 From: "1234",
        //                 Amount: 10000,
        //                 Type: "Member",
        //                 MaximumIncomePerPayment: 1000,
        //             },
        //             {
        //                 Id: 2222,
        //                 From: "2222",
        //                 Amount: 10000,
        //                 Type: "Inherited",
        //                 MaximumIncomePerPayment: 2000,
        //             },
        //         ],
        //     };
        // }
        // if (
        //     _data?.Contribution?.DrawdownModel &&
        //     _data?.Contribution?.DrawdownModel?.DrawdownType === DrawdownType.Capped
        // ) {
        //     _data.Contribution.DrawdownModel.GadRates = {
        //         GadMaximum: 20000,
        //         NextGadMaximum: 10000,
        //     };
        // }

        // if (_data?.Contribution?.DrawdownModel?.Income) {
        //     _data.Contribution.DrawdownModel.Income.MaximumIncomePerPayment = {
        //         Amount: 1000,
        //         Currency: CurrencyCode.GBP,
        //     };
        // }

        // return _data;

        return JSON.parse(JSON.stringify(this.getState().data));
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): TopUpWithITFLSStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    onTopUpWithITFLSResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
